module.exports = __webpack_public_path__ + "static/media/rightArrow.0a2389ba.svg";